var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1271_20486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56812 11.8128L4.66512 10.4702L1.05933 22.6575L4.22733 21.0648L5.96233 24.0001L9.56812 11.8128Z",
    fill: "url(#paint0_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.611 10.73L5.33423 11.6228L7.03625 17.8474L8.95942 11.6464L5.611 10.73Z",
    fill: "url(#paint1_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25098 18.6336L7.39454 19.1593L9.56797 11.8136L9.38173 11.7632L7.25098 18.6336Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14097 10.6011L1.52612 22.4225L2.06997 22.1494L5.61109 10.7299L5.14097 10.6011Z",
    fill: "url(#paint2_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03622 17.8472L5.41504 23.0745L5.71574 23.5834L7.25092 18.6329L7.03622 17.8472Z",
    fill: "url(#paint3_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03662 17.8469L7.25131 18.6327L9.38207 11.7623L8.9598 11.646L7.03662 17.8469Z",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0828 8.93359L5.15332 10.1816L8.30322 21.7026L10.2232 18.9166L13.2334 20.4552L10.0828 8.93359Z",
    fill: "url(#paint4_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56836 10.0764L8.58763 21.29L8.91419 20.8165L5.99322 9.96875L5.56836 10.0764Z",
    fill: "url(#paint5_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77813 9.01123L9.35327 9.11886L12.2736 19.9654L12.8 20.2342L9.77813 9.01123Z",
    fill: "url(#paint6_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02627 7.26736L8.85749 7.21634L9.02627 7.16533L14.8352 5.409L14.4259 4.45774L14.0166 3.50647L8.61693 6.21406L8.46043 6.29245L8.54191 6.14189L11.3588 0.947576L10.37 0.553756L9.38193 0.159314L7.55381 5.74745L7.50014 5.90983L7.44776 5.74745L5.62223 0.158691L4.63348 0.552511L3.64473 0.946331L6.45901 6.14127L6.54049 6.29183L6.384 6.21344L0.985008 3.50336L0.57567 4.45463L0.165686 5.40589L5.97401 7.16471L6.14279 7.21572L5.97401 7.26674L0.165039 9.02244L0.574377 9.97433L0.983715 10.9256L6.38335 8.21738L6.53984 8.13899L6.45837 8.28955L3.6415 13.4839L4.63025 13.8783L5.619 14.2721L7.44647 8.68399L7.50014 8.52223L7.55317 8.68399L9.37805 14.2728L10.3674 13.8789L11.3562 13.4851L8.54127 8.29017L8.45979 8.13961L8.61628 8.218L14.0153 10.9281L14.4246 9.97744L14.8346 9.02617L9.02627 7.26736Z",
    fill: "url(#paint7_radial_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89227 7.81978L8.75647 7.71091L8.93236 7.72522L15 8.21672L14.9961 7.18768L14.9916 6.15803L8.92848 6.69556L8.75259 6.71112L8.88709 6.60162L13.5392 2.82144L12.7794 2.09602L12.0202 1.37122L8.12791 5.87619L8.01474 6.00684L8.02962 5.83762L8.54048 0L7.47025 0.00435504L6.40067 0.00808793L6.95939 5.84197L6.97556 6.0112L6.86174 5.88117L2.93262 1.40543L2.17861 2.13646L1.42525 2.86748L6.10773 6.61219L6.24353 6.72045L6.06764 6.70614L0 6.21464L0.00387998 7.2443L0.00840662 8.27333L6.07217 7.73579L6.24806 7.72024L6.11291 7.82974L1.46081 11.6099L2.22064 12.3353L2.98047 13.0601L6.87274 8.55516L6.98526 8.42451L6.97038 8.59374L6.45952 14.4314L7.52975 14.4276L8.59933 14.4233L8.04061 8.59L8.02444 8.42078L8.13826 8.55019L12.0674 13.0259L12.8214 12.2949L13.5748 11.5645L8.89227 7.81978Z",
    fill: "url(#paint8_radial_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49987 0.421387C3.59855 0.421387 0.437012 3.46369 0.437012 7.21649C0.437012 10.9693 3.59855 14.0116 7.49987 14.0116C11.4012 14.0116 14.5621 10.9693 14.5621 7.21649C14.5621 3.46369 11.3999 0.421387 7.49987 0.421387Z",
    fill: "url(#paint9_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 0.719727C3.77064 0.719727 0.748779 3.62827 0.748779 7.21558C0.748779 10.8029 3.77128 13.7114 7.49994 13.7114C11.2286 13.7114 14.2511 10.8029 14.2511 7.21558C14.2511 3.62827 11.2286 0.719727 7.49994 0.719727Z",
    fill: "url(#paint10_radial_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49989 2.21502L6.82542 1.03418L6.41867 2.32327L5.50364 1.30357L5.38595 2.64554L4.2698 1.83302L4.44505 3.16877L3.17759 2.59702L3.63737 3.86931L2.2742 3.56197L2.99782 4.71481L1.59779 4.68681L2.5555 5.66919L1.18069 5.92365L2.33046 6.69138L1.04102 7.21523L2.33046 7.73845L1.18069 8.50681L2.5555 8.76126L1.59779 9.74364L2.99782 9.71564L2.2742 10.8685L3.63737 10.5611L3.17759 11.8334L4.44505 11.2617L4.26916 12.5974L5.38595 11.7849L5.50364 13.1269L6.41867 12.1072L6.82542 13.3963L7.49989 12.2161L8.17436 13.3963L8.58176 12.1072L9.49614 13.1269L9.61383 11.7849L10.7306 12.5974L10.5547 11.2611L11.8222 11.8334L11.3624 10.5611L12.7256 10.8685L12.002 9.71502L13.402 9.74364L12.4443 8.76064L13.8191 8.50681L12.6693 7.73845L13.9588 7.21523L12.6693 6.69138L13.8191 5.92365L12.4443 5.66919L13.402 4.68681L12.002 4.71543L12.7256 3.56197L11.3624 3.86931L11.8222 2.59702L10.5547 3.16939L10.7306 1.83302L9.61383 2.64554L9.49614 1.30357L8.58176 2.32327L8.17436 1.03418L7.49989 2.21502Z",
    fill: "url(#paint11_radial_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49985 2.47705C4.77869 2.47705 2.57422 4.59858 2.57422 7.21596C2.57422 9.83333 4.77934 11.9555 7.49985 11.9555C10.2204 11.9555 12.4255 9.83396 12.4255 7.21596C12.4255 4.59795 10.2197 2.47705 7.49985 2.47705Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2783 7.21571C12.2783 9.7547 10.1392 11.8128 7.50012 11.8128C4.86109 11.8128 2.72192 9.7547 2.72192 7.21571C2.72192 4.67672 4.86173 2.61865 7.50012 2.61865C10.1385 2.61865 12.2783 4.67672 12.2783 7.21509V7.21571Z",
    fill: "url(#paint12_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1498 7.21641C12.1498 9.68696 10.0682 11.6897 7.50034 11.6897C4.93244 11.6897 2.85083 9.68696 2.85083 7.21641C2.85083 4.74586 4.93244 2.74316 7.50034 2.74316C10.0682 2.74316 12.1498 4.74586 12.1498 7.21641Z",
    fill: "url(#paint13_linear_1271_20486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.957 7.21643C11.957 9.58432 9.96203 11.5037 7.50083 11.5037C5.03963 11.5037 3.04468 9.58432 3.04468 7.21643C3.04468 4.84853 5.04028 2.9292 7.50083 2.9292C9.96139 2.9292 11.957 4.84853 11.957 7.21643Z",
    fill: "url(#paint14_linear_1271_20486)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1271_20486",
    x1: 4.54289,
    y1: 19.8409,
    x2: 6.34465,
    y2: 13.2622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1271_20486",
    x1: 8.30759,
    y1: 17.8044,
    x2: 7.48201,
    y2: 13.0649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1271_20486",
    x1: 4.53311,
    y1: 12.9864,
    x2: 2.28822,
    y2: 22.0148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1271_20486",
    x1: 7.46884,
    y1: 17.4229,
    x2: 6.10671,
    y2: 21.8557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1271_20486",
    x1: 10.2471,
    y1: 19.2109,
    x2: 8.48617,
    y2: 12.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1271_20486",
    x1: 6.70455,
    y1: 13.0907,
    x2: 8.328,
    y2: 20.7911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1271_20486",
    x1: 10.5315,
    y1: 12.2844,
    x2: 12.1549,
    y2: 19.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1271_20486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.50717 7.2225) rotate(21.7375) scale(7.45515 7.25158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1271_20486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.50711 7.22454) rotate(43.6633) scale(7.35655 7.34878)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1271_20486",
    x1: 7.49987,
    y1: 13.2725,
    x2: 7.49987,
    y2: 0.553905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1271_20486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.49994 7.21558) scale(6.75181 6.49585)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1271_20486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.49989 7.21522) scale(6.44141 6.19722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1271_20486",
    x1: 7.50012,
    y1: 3.00127,
    x2: 7.50012,
    y2: 11.5496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ACACAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1271_20486",
    x1: 7.50034,
    y1: 11.4383,
    x2: 7.50034,
    y2: 2.87755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ACACAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1271_20486",
    x1: 7.50019,
    y1: 3.7467,
    x2: 7.50019,
    y2: 10.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ACACAC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_20486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeSilver);
export default __webpack_public_path__ + "static/media/badge_silver.e8f81a554c8fe668d9cbbc594e40c49e.svg";
export { ForwardRef as ReactComponent };